import React from 'react';
import Dialog from '@components/Atoms/Dialog';
import Typography from '@components/Atoms/Typography';
import { STATE } from './SlideControls';

interface SlideEditReminderModalProps {
  open: boolean;
  reviewState: string;
  onCompare: () => void;
  onSave: () => void;
  onSkip: () => void;
  onTeachCurrent: () => void;
  onTeachNew: () => void;
  onCancel: () => void;
}

const SlideEditReminderModal: React.FC<SlideEditReminderModalProps> = ({
  open,
  reviewState,
  onCompare,
  onSave,
  onSkip,
  onTeachCurrent,
  onTeachNew,
  onCancel,
}) => {
  const isDraftScenario = reviewState === STATE.DRAFT;

  const dialogActions = isDraftScenario
    ? [
        {
          label: 'Skip',
          onClick: onSkip,
          buttonProps: { variant: 'outlined' as const, color: 'inherit' as const },
        },
        {
          label: 'Compare',
          onClick: onCompare,
          buttonProps: { variant: 'outlined' as const, color: 'primary' as const },
        },
        {
          label: 'Save',
          onClick: onSave,
          buttonProps: { variant: 'contained' as const, color: 'primary' as const },
        },
      ]
    : [
        {
          label: 'Teach current slides',
          onClick: onTeachCurrent,
          buttonProps: { variant: 'outlined' as const, color: 'inherit' as const },
        },
        {
          label: 'Compare',
          onClick: onCompare,
          buttonProps: { variant: 'outlined' as const, color: 'primary' as const },
        },
        {
          label: 'Teach new slides',
          onClick: onTeachNew,
          buttonProps: { variant: 'contained' as const, color: 'primary' as const },
        },
      ];

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      title={
        isDraftScenario
          ? "Don't forget your slide edits!"
          : 'You have a new slide version'
      }
      actions={dialogActions}
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1,
        },
      }}
    >
      <Typography variant="body1" color="text.secondary">
        {isDraftScenario
          ? "You haven't saved your new slide version yet, would you like to compare and/or save?"
          : 'You have saved a new slide version but not selected it, would you like to teach it?'}
      </Typography>
    </Dialog>
  );
};

export default SlideEditReminderModal;
